import { PermissionAccessTypes } from '../accounts/account';

export const USE_DEFAULT = 'USE_DEFAULT' as const;
export interface IAccountPermissionDto {
  name: string;
  accessLevel: PermissionAccessTypes | typeof USE_DEFAULT;
}

export interface UpdateAccountPolicy {
  accountId: string;
  permissions: Array<IAccountPermissionDto>;
}
